export default {
  desktopView: {
    margin: '0 auto',
  }
};
